(ns journal-app-client.effects
  (:require [re-frame.core :as rf]
            [journal-app-client.routes :as routes]
            [journal-app-client.utils.interop :as interop]
            [journal-app-client.utils.css :refer [set-theme]]))

(rf/reg-event-fx :dispatch-effect
  (fn [_ [_ effect-event]]
    {:fx [effect-event]}))

;; --- Register effects. Effects are not events and can not be dispatched as events.-----------
;;
;; Works the same as dispatch-later but we can cancel the dispatch if needed
(rf/reg-fx :timeout-dispatch
  (fn [props]
    (interop/set-timeout props)))

(rf/reg-fx :interval                                          ;; Running event at a set interval
  (fn [props]
    (interop/set-interval props)))

(rf/reg-fx
  :dispatch-debounce
  (fn [[id event-vec ms]]
    (interop/debounce id #(rf/dispatch event-vec) ms)))

(rf/reg-fx
  :dispatch-throttle
  (fn [[id event-vec ms]]
    (interop/throttle id #(rf/dispatch event-vec) ms)))

(rf/reg-fx :scroll-to
  (fn [props]
    (interop/scroll-to props)))

(rf/reg-fx :scroll-by
  (fn [props]
    (interop/scroll-by props)))

(rf/reg-fx :scroll-into-view
  (fn [props]
    (interop/scroll-into-view props)))

(rf/reg-fx :set-scroll-position
  (fn [props]
    (interop/set-scroll-position props)))

(rf/reg-fx :init-game-server-url
  (fn [url]
    (interop/set-url url)))

(rf/reg-fx :set-url
  (fn [url]
    (interop/set-url url)))

(rf/reg-fx :open-url
  (fn [[url behaviour]]
    (interop/open-url url behaviour)))

(rf/reg-fx :set-anchor
  (fn [anchor]
    (interop/set-anchor anchor)))

(rf/reg-fx :add-event-listener
  (fn [props]
    (interop/add-event-listener props)))

(rf/reg-fx :focus-element
  (fn [props]
    (interop/focus props)))

(rf/reg-fx :swap!
  (fn [[a function]]
    (when (and a function) (swap! a function))))

(rf/reg-fx :reset!
  (fn [[a new-value]]
    (when a (reset! a new-value))))

(rf/reg-fx :set-theme
  (fn [theme]
    (set-theme theme)))

(rf/reg-fx :local-storage
  (fn [[action k v]]
    (case action
      :set-item (interop/local-storage action k v)
      :clear (interop/local-storage action)
      :remove-item (interop/local-storage action k)
      nil)))

(rf/reg-fx :routes-push-state
  (fn [[view props]]
    (routes/push-state view props)))

(rf/reg-fx :routes-forward
  (fn [_] (routes/forward)))

(rf/reg-fx :routes-back
  (fn [_] (routes/back)))
